<script>
import Vue from "vue";
import { DoctuUser } from "@models/parser/DoctuUser";
let bcrypt = require('bcryptjs');
export default {
    props: {
        permissions: {
            type: Array,
            required: false
        },
        roles: {
            type: Array,
            required: false
        },
        userOptions: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            user: new DoctuUser(),
            freeLogin: true,
            passwordVisible: false,
            password: '',
            Mhashcode: null,
        };
    },
    watch: {
        password (n) {
            this.calculateHash(n);
        },
    },
    methods: {
        calculateHash: _.debounce(function(n) {
            this.user.passwordHash = (n ==='') ? '' :bcrypt.hashSync(n)
        }, 70),
        openUserEdition(data) {
            let user = new DoctuUser(data);
            Vue.set(this, 'user', user);
            let requestPromise = this.axios.get('users/read/'+ user.id);
            requestPromise.then(response => {
                Vue.set(this, 'user', new DoctuUser(response.data));
                this.$refs.userDialog.show();
            });

            setTimeout(() => {
                this.Mhashcode = JSON.stringify(this.user).hashCode();
            }, 500)
            return requestPromise;
        },
        openUserCreation() {
            let promise = new Promise((resolve, reject) => {
                this.$refs.userDialog.show();
                resolve(true);
            });
            return promise;
        },
        checkLogin() {
            this.axios.post('/checkUserLogin', {login: this.user.login, id: this.user.id}).then((data) => {
                this.freeLogin = data.data.result === "free";
            });
        },

        checkEmail() {
            this.axios.post('users/checkEmail', this.user, function (data) {
                if (data.status === 'OK') {
                    alert('Все верно!');
                } else {
                    alert(
                        'Не удалось отправить тестовое письмо!\n\n' +
                        data.exception + '\n' +
                        data.message);
                }
            });
            return false;
        },

        hidePassword() {
            this.passwordVisible = false;
        },
        showPassword() {
            this.passwordVisible = true;
        },
        genPassword() {
            Vue.set(this, 'password', this.$root.pwgen());
        },
        saveUser() {
            if(!this.needSave){
                return;
            }
            this.$refs.userEditForm.validate().then((success) => {
                if (!success) {
                    return false;
                }

                this.axios.post('users/update/'+this.user.id, this.user).then(() => {
                    if (this.user.self === true) {
                        window.location.reload();
                    } else {
                        this.closeDialog();
                    }
                });
            });
            return false;
        },
        resetPassword() {
            this.$modal(`Новый пароль будет отправлен на почту ${this.user.email}. Продолжить?`, {
                name: 'Да',
                callback: () => {
                    this.axios.post('/forgot-password', {
                        userEmail: this.user.email,
                        userId: this.user.id,
                    }).then((res) => {console.log(res.data)})
                }
            }, {
                name: 'Нет',
            });
        },
        saveNewUser() {
            this.$refs.userEditForm.validate().then((success) => {
                if (!success) {
                    return false;
                }
                this.axios.post('users/create', this.user).then(() => {
                    if (this.user.self === true) {
                        window.location.reload();
                    } else {
                        this.closeDialog();
                    }
                });
            });
            return false;
        },

        deleteUser() {
            this.$modal('Удалить пользователя?', {
                    callback: (e) => {
                        this.axios.post('users/delete/'+this.user.id).then(() => {
                            this.closeDialog();
                        });
                    }
                }, {
                    callback: () => {

                    }
                }
            );

            return false;
        },

        resetComponentData() {
            Vue.set(this, 'user', new DoctuUser());
            Vue.set(this, 'passwordVisible', false);
            Vue.set(this, 'password', '');
            this.Mhashcode = null
        },
        closeDialog(reload = true) {
            this.resetComponentData();
            if(this.$refs.userDialog){
              this.$refs.userDialog.hide();
            }
            if (reload){
                this.$emit('reloadTable');
            }
        },
        collapseAll() {
            this.$refs.permission.forEach(item => item.collapse());
        },
        expandAll() {
            this.$refs.permission.forEach(item => item.expand());
        }
    }
}
</script>

<style>
#userDialog {
    width: 700px;
}
</style>
